import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import styles from './LoginForm.module.css';

const APPLE_SDK_SRC = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

const AppleSignInReturn = () => {
    useEffect(() => {
        if (window.AppleID || document.getElementById('appleid-signin-sdk')) {
            return;
        }
        const script = document.createElement('script');
        script.id = 'appleid-signin-sdk';
        script.src = APPLE_SDK_SRC;
        script.async = true;
        document.head.appendChild(script);
    }, []);

    return (
        <div className={styles.spinner}><FontAwesomeIcon icon={faBolt} size="3x" /></div>
    );
};

export default AppleSignInReturn;
